var CONFUSEDCMS = CONFUSEDCMS || {};
CONFUSEDCMS.ProductHeroCTA = CONFUSEDCMS.ProductHeroCTA || {};

(function (ns, $) {
    'use strict';

    ns.Constants = {
        CAR: 0,
        VAN: 1,
        BIKE: 2
    };


    ns.Vehicle = function () {
        var self = this;
        self.RegNumber = ko.observable('');
        self.VehicleType = ko.observable('');
    };

    ns.BaseUrl = function () {
        return $('.js-get-a-quote-btn').attr('href');
    };

    ns.RegNumberLookup = function () {
        var self = this;
        self.Vehicle = new ns.Vehicle();
        self.VehicleNotFound = ko.observable(false);
        self.VanFound = ko.observable(false);
        self.BikeFound = ko.observable(false);

        self.ShowModalDimmer = ko.computed(function () {
            if (self.VehicleNotFound() || self.VanFound() || self.BikeFound()) {
                $('.modal-dimmer').show();
                return true;
            }
            $('.modal-dimmer').hide();
            return false;
        });

        self.InitialiseModule = function () {
            ko.applyBindings(self);
        };

        self.Reset = function () {
            self.VanFound(false);
            self.BikeFound(false);
            self.VehicleNotFound(false);
        };

        self.EditReg = function () {
            self.Reset();
            $('.js-get-a-quote-input').focus();
            $('.js-get-a-quote-input').select();
        };

        self.Lookup = function () {
            var regNumber = $('.js-get-a-quote-input').val();
            var baseUrl = ns.BaseUrl();
            if (regNumber === '') {
                window.location.href = baseUrl;
                return;
            }
            self.Vehicle.VehicleType(ns.Constants.CAR);
            self.Vehicle.RegNumber(regNumber);
            var carRegQuoteUrl = $('.js-get-a-quote-input').attr('data-quote-entry-url');
            

            $.ajax({
                url: '/api/lookupv2/vehiclelookup',
                contentType: 'text/json',
                type: 'POST',
                data: ko.toJSON({
                    RegistrationNumber: self.Vehicle.RegNumber()
                }),
                success: function (data) {
                    switch (data) {
                        case ns.Constants.CAR:
                            window.location.href = baseUrl + carRegQuoteUrl + self.Vehicle.RegNumber();
                            return;
                        case ns.Constants.VAN:
                            self.VanFound(true);
                            break;
                        case ns.Constants.BIKE:
                            self.BikeFound(true);
                            break;
                        default:
                            self.VehicleNotFound(true);
                    }


                },
                error: function () {
                    self.VehicleNotFound(true);
                }
            });
        };
    };

    ns.PostcodeLookup = function() {
        var self = this;

        self.InitialiseModule = function () {
            ko.applyBindings(self);
        };

        self.CheckPostcode = function (regValue) {
            regValue = $.trim(regValue);
            var regPostcode =
                new RegExp(
                    '^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) {0,1}[0-9][A-Za-z]{2})$');
            if (regPostcode.test(regValue)) {
                return true;
            } else {
                if ($('.input-with-button + .error-message').length < 1) {
                    var $errorMsg = $('<p/>', { text: 'Please enter a valid postcode', 'class': 'error-message' });
                    $errorMsg.insertAfter('.input-with-button');
                }
                return false;
            }
        };

        self.Lookup = function () {
            var postCode = $('.js-get-a-quote-input').val();
            var baseUrl = ns.BaseUrl();
            if (postCode === '') {
                window.location.href = baseUrl;
                return;
            }
            
            var postCodeQuoteUrl = $('.js-get-a-quote-input').attr('data-quote-entry-url');

            if (self.CheckPostcode(postCode)) {
                window.location.href = baseUrl + postCodeQuoteUrl + postCode;
            }

            
        };
    };

    CONFUSEDCMS.setupProductCtas = function() {
        if ($('input.js-get-a-quote-input[data-quote-product-id="2"]').length > 0) {

            var motorHeroCta = new CONFUSEDCMS.ProductHeroCTA.RegNumberLookup();
            motorHeroCta.InitialiseModule();

            $('input.js-get-a-quote-input').on('keydown',
                function (e) {
                    if (e.keyCode === 13) {
                        e.preventDefault();
                        motorHeroCta.Lookup();
                    }
                });
        }

        if ($('input.js-get-a-quote-input[data-quote-product-id="5"]').length > 0) {

            var homeHeroCta = new CONFUSEDCMS.ProductHeroCTA.PostcodeLookup();
            homeHeroCta.InitialiseModule();

            $('input.js-get-a-quote-input').on('keydown',
                function (e) {
                    if (e.keyCode === 13) {
                        e.preventDefault();
                        homeHeroCta.Lookup();
                    }
                });
        } 
    };

}(CONFUSEDCMS.ProductHeroCTA, jQuery));
